import React from 'react';
import styles from './CLMandatoryFieldMarker.module.scss';

function CLMandatoryFieldMarker() {
  return <span className={styles.mandatory_field_marker}>&nbsp;*</span>;
}

export default CLMandatoryFieldMarker;
